import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
// component, hooks
import NormalDisplay from "../../../../../../common/components/resultDisplay/NormalDisplay";
// store
import { StoreContext } from "../../../../../../store/StoreProvider";
// config,utils

// style

const BasicTable = ({ headers, rows }) => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { snaDisplay } = sna;
  // local state
  const [rowsPerPage, setRowsPerPage] = useState(-1); // 沒有限制
  // hooks

  // 依據個別欄位分別取的要標註的 keyword
  const getKeyword = (row, header) => "";

  return (
    <Box mt={0} mb={3}>
      <Grid item>
        {/* 若有不同型式的表格, 這裡可以切換 */}
        <NormalDisplay
          curResult={rows}
          headers={headers}
          // keyword={preSearchValue}
          getKeyword={getKeyword}
          // markStyle={markStyle}
          // fontSize={getFontsizeVal(fontSize)}
          rowsPerPageOptions={[{ label: "All", value: -1 }]}
          forceResetPage={false}
          dataUniqKey="id"
          // page={
          //   // component 的 page 會從 0 開始, 所以必須再 -1
          //   currentPage <= 0 ? currentPage : currentPage - 1
          // }
          rowsPerPage={rowsPerPage}
          onPageChange={(pageVal, _rowsPerPage) => {
            // // component 的 page 會從 0 開始, 所以必須再 +1
            // searchEventDispatch({
            //   type: SearchEventAct.SET_CUR_PAGE,
            //   payload: pageVal + 1,
            // });
            // const { limit, offset } = getLimitOffset(
            //   pageVal + 1,
            //   _rowsPerPage || pages.rowsPerPage
            // );
            //
            // searchEventDispatch({
            //   type: SearchEventAct.SET_PAGES,
            //   payload: {
            //     rowsPerPage: _rowsPerPage || pages.rowsPerPage,
            //     limit,
            //     offset,
            //   },
            // });
          }}
          onRowsPerPageChange={(val) => {
            setRowsPerPage(val);
            // const { limit, offset } = getLimitOffset(1, val);
            // searchEventDispatch({
            //   type: SearchEventAct.SET_PAGES,
            //   payload: {
            //     rowsPerPage: val,
            //     limit,
            //     offset,
            //   },
            // });
          }}
          onCurPageRowsChange={(_rows) => {
            // console.log("onCurPageRowsChange", _rows)
            // searchEventDispatch({
            //   type: SearchEventAct.SET_CUR_PAGE_ROWS,
            //   payload: rows,
            // });
          }}
        />
      </Grid>
    </Box>
  );
};

BasicTable.propTypes = {
  headers: PropTypes.objectOf(PropTypes.any),
  rows: PropTypes.arrayOf(PropTypes.any),
};

BasicTable.defaultProps = {
  headers: {},
  rows: [],
};

export default BasicTable;
